import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateDocumentActions as Actions,
  CreateDocumentRequestAction as RequestAction,
} from 'store/ducks/documents';

export function* createDocumentRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `documents`, postData);
    onSuccess && onSuccess();
    notify('success', 'Documento criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    const message = validationErrors?.map(({ message }) => message).join(', ');
    onFailure && onFailure();
    notify('error', message || errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
